import React, { useState } from "react"; 
import axios from 'axios';
import Toastr from "./Toastr";

const countries = [
    { code: "AF", name: "Afghanistan", phoneCode: "+93" },
    { code: "PK", name: "Pakistan", phoneCode: "+92" },
    { code: "AX", name: "Åland Islands", phoneCode: "+358" },
    { code: "YE", name: "Yemen", phoneCode: "+967" },
    { code: "ZM", name: "Zambia", phoneCode: "+260" },
    { code: "ZW", name: "Zimbabwe", phoneCode: "+263" },
    { code: "OM", name: "Oman", phoneCode: "+968" }, // Fixed phone code for Oman
  ];
const WriteToUs = () => {
    const [selectedCountry, setSelectedCountry] = useState(countries[1].code);
  const [phoneNumber, setPhoneNumber] = useState("");
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    subject: "",
    comment: "",
    website: "alphai"
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState(null);
  const [toastrs, setToastrs] = useState([]);
  const addToastr = (message, type) => {
    const id = Date.now();
    const newToastr = { id, message, type };
    setToastrs(prev => [...prev, newToastr]);
    
    // Auto-remove after 3 seconds
    setTimeout(() => {
      removeToastr(id);
    }, 3000);
  };
  const removeToastr = (id) => {
    setToastrs(prev => prev.filter(toastr => toastr.id !== id));
  };
  const handleCountryChange = (e) => {
    setSelectedCountry(e.target.value);
  };

  const handlePhoneNumberChange = (e) => {
    setPhoneNumber(e.target.value);
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setSubmitStatus(null);
    
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/Email/SendEmail`,
        formData,
        {
          headers: {
            'Content-Type': 'application/json'
          }
        }
      );
      addToastr("Message sent successfully!", "success");
      setSubmitStatus({ success: true, message: "Message sent successfully!" });
      // Reset form after successful submission
      setFormData({
        name: "",
        email: "",
        subject: "",
        comment: "",
        website: "alphai"
      });
      setPhoneNumber("");
    } catch (error) {
      console.error("Error submitting form:", error);
      addToastr("Failed to send message. Please try again.", "error");
      setSubmitStatus({ success: false, message: "Failed to send message. Please try again." });
    } finally {
      setIsSubmitting(false);
    }
  };


    return (
        <>
          {toastrs.map(toastr => (
          <Toastr 
            key={toastr.id}
            message={toastr.message}
            type={toastr.type}
            onClose={() => removeToastr(toastr.id)}
          />
        ))}
            <section
                className="businessForm-module--business_form--4bdcb pt-110"
                id="hirescroll"
            >
                <div className="container">
                    <form onSubmit={handleSubmit}>
                        <div className="businessForm-module--business_form_wrap--c85b3">
                            <div className="businessForm-module--business_form_left--f9c89">
                                <h2 className="businessForm-module--ptSans--61e94">
                                    Start growing your business with us
                                </h2>
                                <ul className="businessForm-module--business_form_listing--a281f">
                                    <li>
                                        <div className="businessForm-module--two_col--af684">
                                            <div className="businessForm-module--form_grp--37aa0">
                                                <label
                                                    
                                                    className="style-module--d_none--a31f5"
                                                    aria-label="Full Name*"
                                                >
                                                    Full Name*
                                                </label>
                                                <input
                                                    type="text"
                                                    className="businessForm-module--input_grp--9a08e"
                                                    placeholder="Full Name*"
                                                    name="name"
                                                    value={formData.name}
                                                    onChange={handleInputChange}
                                                    required
                                                />
                                            </div>
                                        </div>
                                        <div className="businessForm-module--two_col--af684">
                                            <div className="businessForm-module--form_grp--37aa0">
                                                <label
                                                    
                                                    className="style-module--d_none--a31f5"
                                                    aria-label="Phone Number*"
                                                >
                                                    Phone Number*
                                                </label>
                                                <div className="businessForm-module--input_grp--9a08e PhoneInput">
                                                    <div className="PhoneInputCountry">
                                                        <select
                                                            value="OM"
                                                            name="phoneCountry"
                                                            aria-label="Phone number country"
                                                            className="PhoneInputCountrySelect"
                                                        >
                                                            <option value="AF">Afghanistan</option>
                                                            <option value="AX">Åland Islands</option>
                                                            <option value="AL">Albania</option>
                                                            <option value="DZ">Algeria</option>
                                                            <option value="AS">American Samoa</option>
                                                            <option value="AD">Andorra</option>
                                                            <option value="AO">Angola</option>
                                                            <option value="AI">Anguilla</option>
                                                            <option value="AG">Antigua and Barbuda</option>
                                                            <option value="AR">Argentina</option>
                                                            <option value="AM">Armenia</option>
                                                            <option value="AW">Aruba</option>
                                                            <option value="AC">Ascension Island</option>
                                                            <option value="AU">Australia</option>
                                                            <option value="AT">Austria</option>
                                                            <option value="AZ">Azerbaijan</option>
                                                            <option value="BS">Bahamas</option>
                                                            <option value="BH">Bahrain</option>
                                                            <option value="BD">Bangladesh</option>
                                                            <option value="BB">Barbados</option>
                                                            <option value="BY">Belarus</option>
                                                            <option value="BE">Belgium</option>
                                                            <option value="BZ">Belize</option>
                                                            <option value="BJ">Benin</option>
                                                            <option value="BM">Bermuda</option>
                                                            <option value="BT">Bhutan</option>
                                                            <option value="BO">Bolivia</option>
                                                            <option value="BQ">
                                                                Bonaire, Sint Eustatius and Saba
                                                            </option>
                                                            <option value="BA">Bosnia and Herzegovina</option>
                                                            <option value="BW">Botswana</option>
                                                            <option value="BR">Brazil</option>
                                                            <option value="IO">
                                                                British Indian Ocean Territory
                                                            </option>
                                                            <option value="BN">Brunei Darussalam</option>
                                                            <option value="BG">Bulgaria</option>
                                                            <option value="BF">Burkina Faso</option>
                                                            <option value="BI">Burundi</option>
                                                            <option value="KH">Cambodia</option>
                                                            <option value="CM">Cameroon</option>
                                                            <option value="CA">Canada</option>
                                                            <option value="CV">Cape Verde</option>
                                                            <option value="KY">Cayman Islands</option>
                                                            <option value="CF">
                                                                Central African Republic
                                                            </option>
                                                            <option value="TD">Chad</option>
                                                            <option value="CL">Chile</option>
                                                            <option value="CN">China</option>
                                                            <option value="CX">Christmas Island</option>
                                                            <option value="CC">
                                                                Cocos (Keeling) Islands
                                                            </option>
                                                            <option value="CO">Colombia</option>
                                                            <option value="KM">Comoros</option>
                                                            <option value="CG">Congo</option>
                                                            <option value="CD">
                                                                Congo, Democratic Republic of the
                                                            </option>
                                                            <option value="CK">Cook Islands</option>
                                                            <option value="CR">Costa Rica</option>
                                                            <option value="CI">Cote d&#x27;Ivoire</option>
                                                            <option value="HR">Croatia</option>
                                                            <option value="CU">Cuba</option>
                                                            <option value="CW">Curaçao</option>
                                                            <option value="CY">Cyprus</option>
                                                            <option value="CZ">Czech Republic</option>
                                                            <option value="DK">Denmark</option>
                                                            <option value="DJ">Djibouti</option>
                                                            <option value="DM">Dominica</option>
                                                            <option value="DO">Dominican Republic</option>
                                                            <option value="EC">Ecuador</option>
                                                            <option value="EG">Egypt</option>
                                                            <option value="SV">El Salvador</option>
                                                            <option value="GQ">Equatorial Guinea</option>
                                                            <option value="ER">Eritrea</option>
                                                            <option value="EE">Estonia</option>
                                                            <option value="ET">Ethiopia</option>
                                                            <option value="FK">Falkland Islands</option>
                                                            <option value="FO">Faroe Islands</option>
                                                            <option value="FM">
                                                                Federated States of Micronesia
                                                            </option>
                                                            <option value="FJ">Fiji</option>
                                                            <option value="FI">Finland</option>
                                                            <option value="FR">France</option>
                                                            <option value="GF">French Guiana</option>
                                                            <option value="PF">French Polynesia</option>
                                                            <option value="GA">Gabon</option>
                                                            <option value="GM">Gambia</option>
                                                            <option value="GE">Georgia</option>
                                                            <option value="DE">Germany</option>
                                                            <option value="GH">Ghana</option>
                                                            <option value="GI">Gibraltar</option>
                                                            <option value="GR">Greece</option>
                                                            <option value="GL">Greenland</option>
                                                            <option value="GD">Grenada</option>
                                                            <option value="GP">Guadeloupe</option>
                                                            <option value="GU">Guam</option>
                                                            <option value="GT">Guatemala</option>
                                                            <option value="GG">Guernsey</option>
                                                            <option value="GN">Guinea</option>
                                                            <option value="GW">Guinea-Bissau</option>
                                                            <option value="GY">Guyana</option>
                                                            <option value="HT">Haiti</option>
                                                            <option value="VA">
                                                                Holy See (Vatican City State)
                                                            </option>
                                                            <option value="HN">Honduras</option>
                                                            <option value="HK">Hong Kong</option>
                                                            <option value="HU">Hungary</option>
                                                            <option value="IS">Iceland</option>
                                                            <option value="IN">India</option>
                                                            <option value="ID">Indonesia</option>
                                                            <option value="IR">Iran</option>
                                                            <option value="IQ">Iraq</option>
                                                            <option value="IE">Ireland</option>
                                                            <option value="IM">Isle of Man</option>
                                                            <option value="IL">Israel</option>
                                                            <option value="IT">Italy</option>
                                                            <option value="JM">Jamaica</option>
                                                            <option value="JP">Japan</option>
                                                            <option value="JE">Jersey</option>
                                                            <option value="JO">Jordan</option>
                                                            <option value="KZ">Kazakhstan</option>
                                                            <option value="KE">Kenya</option>
                                                            <option value="KI">Kiribati</option>
                                                            <option value="XK">Kosovo</option>
                                                            <option value="KW">Kuwait</option>
                                                            <option value="KG">Kyrgyzstan</option>
                                                            <option value="LA">Laos</option>
                                                            <option value="LV">Latvia</option>
                                                            <option value="LB">Lebanon</option>
                                                            <option value="LS">Lesotho</option>
                                                            <option value="LR">Liberia</option>
                                                            <option value="LY">Libya</option>
                                                            <option value="LI">Liechtenstein</option>
                                                            <option value="LT">Lithuania</option>
                                                            <option value="LU">Luxembourg</option>
                                                            <option value="MO">Macao</option>
                                                            <option value="MG">Madagascar</option>
                                                            <option value="MW">Malawi</option>
                                                            <option value="MY">Malaysia</option>
                                                            <option value="MV">Maldives</option>
                                                            <option value="ML">Mali</option>
                                                            <option value="MT">Malta</option>
                                                            <option value="MH">Marshall Islands</option>
                                                            <option value="MQ">Martinique</option>
                                                            <option value="MR">Mauritania</option>
                                                            <option value="MU">Mauritius</option>
                                                            <option value="YT">Mayotte</option>
                                                            <option value="MX">Mexico</option>
                                                            <option value="MD">Moldova</option>
                                                            <option value="MC">Monaco</option>
                                                            <option value="MN">Mongolia</option>
                                                            <option value="ME">Montenegro</option>
                                                            <option value="MS">Montserrat</option>
                                                            <option value="MA">Morocco</option>
                                                            <option value="MZ">Mozambique</option>
                                                            <option value="MM">Myanmar</option>
                                                            <option value="NA">Namibia</option>
                                                            <option value="NR">Nauru</option>
                                                            <option value="NP">Nepal</option>
                                                            <option value="NL">Netherlands</option>
                                                            <option value="NC">New Caledonia</option>
                                                            <option value="NZ">New Zealand</option>
                                                            <option value="NI">Nicaragua</option>
                                                            <option value="NE">Niger</option>
                                                            <option value="NG">Nigeria</option>
                                                            <option value="NU">Niue</option>
                                                            <option value="NF">Norfolk Island</option>
                                                            <option value="KP">North Korea</option>
                                                            <option value="MK">North Macedonia</option>
                                                            <option value="MP">
                                                                Northern Mariana Islands
                                                            </option>
                                                            <option value="NO">Norway</option>
                                                            <option value="OM" selected="">
                                                                Oman
                                                            </option>
                                                            <option value="PK">Pakistan</option>
                                                            <option value="PW">Palau</option>
                                                            <option value="PS">Palestine</option>
                                                            <option value="PA">Panama</option>
                                                            <option value="PG">Papua New Guinea</option>
                                                            <option value="PY">Paraguay</option>
                                                            <option value="PE">Peru</option>
                                                            <option value="PH">Philippines</option>
                                                            <option value="PL">Poland</option>
                                                            <option value="PT">Portugal</option>
                                                            <option value="PR">Puerto Rico</option>
                                                            <option value="QA">Qatar</option>
                                                            <option value="RE">Reunion</option>
                                                            <option value="RO">Romania</option>
                                                            <option value="RU">Russia</option>
                                                            <option value="RW">Rwanda</option>
                                                            <option value="BL">Saint Barthélemy</option>
                                                            <option value="SH">Saint Helena</option>
                                                            <option value="KN">Saint Kitts and Nevis</option>
                                                            <option value="LC">Saint Lucia</option>
                                                            <option value="MF">
                                                                Saint Martin (French Part)
                                                            </option>
                                                            <option value="PM">
                                                                Saint Pierre and Miquelon
                                                            </option>
                                                            <option value="VC">
                                                                Saint Vincent and the Grenadines
                                                            </option>
                                                            <option value="WS">Samoa</option>
                                                            <option value="SM">San Marino</option>
                                                            <option value="ST">Sao Tome and Principe</option>
                                                            <option value="SA">Saudi Arabia</option>
                                                            <option value="SN">Senegal</option>
                                                            <option value="RS">Serbia</option>
                                                            <option value="SC">Seychelles</option>
                                                            <option value="SL">Sierra Leone</option>
                                                            <option value="SG">Singapore</option>
                                                            <option value="SX">Sint Maarten</option>
                                                            <option value="SK">Slovakia</option>
                                                            <option value="SI">Slovenia</option>
                                                            <option value="SB">Solomon Islands</option>
                                                            <option value="SO">Somalia</option>
                                                            <option value="ZA">South Africa</option>
                                                            <option value="KR">South Korea</option>
                                                            <option value="SS">South Sudan</option>
                                                            <option value="ES">Spain</option>
                                                            <option value="LK">Sri Lanka</option>
                                                            <option value="SD">Sudan</option>
                                                            <option value="SR">Suriname</option>
                                                            <option value="SJ">Svalbard and Jan Mayen</option>
                                                            <option value="SZ">Swaziland</option>
                                                            <option value="SE">Sweden</option>
                                                            <option value="CH">Switzerland</option>
                                                            <option value="SY">Syria</option>
                                                            <option value="TW">Taiwan</option>
                                                            <option value="TJ">Tajikistan</option>
                                                            <option value="TZ">Tanzania</option>
                                                            <option value="TH">Thailand</option>
                                                            <option value="TL">Timor-Leste</option>
                                                            <option value="TG">Togo</option>
                                                            <option value="TK">Tokelau</option>
                                                            <option value="TO">Tonga</option>
                                                            <option value="TT">Trinidad and Tobago</option>
                                                            <option value="TA">Tristan da Cunha</option>
                                                            <option value="TN">Tunisia</option>
                                                            <option value="TR">Turkey</option>
                                                            <option value="TM">Turkmenistan</option>
                                                            <option value="TC">
                                                                Turks and Caicos Islands
                                                            </option>
                                                            <option value="TV">Tuvalu</option>
                                                            <option value="UG">Uganda</option>
                                                            <option value="UA">Ukraine</option>
                                                            <option value="AE">United Arab Emirates</option>
                                                            <option value="GB">United Kingdom</option>
                                                            <option value="US">United States</option>
                                                            <option value="UY">Uruguay</option>
                                                            <option value="UZ">Uzbekistan</option>
                                                            <option value="VU">Vanuatu</option>
                                                            <option value="VE">Venezuela</option>
                                                            <option value="VN">Vietnam</option>
                                                            <option value="VG">
                                                                Virgin Islands, British
                                                            </option>
                                                            <option value="VI">Virgin Islands, U.S.</option>
                                                            <option value="WF">Wallis and Futuna</option>
                                                            <option value="EH">Western Sahara</option>
                                                            <option value="YE">Yemen</option>
                                                            <option value="ZM">Zambia</option>
                                                            <option value="ZW">Zimbabwe</option>
                                                        </select>
                                                        <div
                                                            aria-hidden="true"
                                                            className="PhoneInputCountryIcon PhoneInputCountryIcon--border"
                                                        >
                                                            <img
                                                                className="PhoneInputCountryIconImg"
                                                                alt="Oman"
                                                                src="https://purecatamphetamine.github.io/country-flag-icons/3x2/OM.svg"
                                                            />
                                                        </div>
                                                        <div className="PhoneInputCountrySelectArrow"></div>
                                                    </div>
                                                    <input
                                                        type="tel"
                                                        autoComplete="tel"
                                                        layout="first"
                                                        name="phone"
                                                        className="PhoneInputInput"
                                                        value="+968"
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </li>
                                    <li>
                                        <div className="businessForm-module--two_col--af684">
                                            <div className="businessForm-module--form_grp--37aa0">
                                                <label
                                                  
                                                    className="style-module--d_none--a31f5"
                                                    aria-label="Email*"
                                                >
                                                    Email*
                                                </label>
                                                <input
                                                    type="email"
                                                    className="businessForm-module--input_grp--9a08e"
                                                    placeholder="Email*"
                                                    name="email"
                                                    value={formData.email}
                                                    onChange={handleInputChange}
                                                    required
                                                />
                                            </div>
                                        </div>
                                        <div className="businessForm-module--two_col--af684">
                                            <div className="businessForm-module--form_grp--37aa0">
                                                <label
                                                   
                                                    className="style-module--d_none--a31f5"
                                                    aria-label="Budget*"
                                                >
                                                    Budget*
                                                </label>
                                                <input
                                                    type="number"
                                                    className="businessForm-module--input_grp--9a08e"
                                                    placeholder="Budget*"
                                                    name="subject"
                                                    value={formData.subject}
                                                    onChange={handleInputChange}
                                                    required
                                                />
                                            </div>
                                        </div>
                                    </li>
                                    <li>
                                        <div className="businessForm-module--full_col--37705">
                                            <div className="businessForm-module--form_grp--37aa0">
                                                <label
                                                    
                                                    className="style-module--d_none--a31f5"
                                                    aria-label="Project Details*"
                                                >
                                                    Project Details*
                                                </label>
                                                <textarea
                                                    type="text"
                                                    className="businessForm-module--input_grp--9a08e"
                                                    placeholder="Project Details*"
                                                    name="comment"
                                                    value={formData.comment}
                                                    onChange={handleInputChange}
                                                    required
                                                ></textarea>
                                            </div>
                                        </div>
                                    </li>
                                    <li>
                                        <div className="businessForm-module--submit_area--e7783">
                                            <div className="businessForm-module--form_grp--37aa0">
                                                <p>
                                                    By sending this form I confirm that I have read and
                                                    accept the 
                                                     <a type="buton"> Privacy Policy</a>
                                                </p>
                                                <button
                                                    className="formButtonRed-module--btn_red--27355 undefined"
                                                  type="submit"
                                                    disabled={isSubmitting}
                                                >
                                                  {isSubmitting ? 'Sending...' : 'Send message'}
                                                </button>
                                            </div>
                                        </div>
                                    </li>
                                </ul>
                            </div>
                            <div className="businessForm-module--business_form_right--8bdb5">
                                <ul className="businessForm-module--review_list--36da9">
                                    <li>
                                        <span className="businessForm-module--rightLabel--f1b4e">
                                            Write to us
                                        </span>
                                        <a
                                            className="businessForm-module--ptSans--61e94"
                                            href="mailTo:info@alphaisolutions.com"
                                        >
                                            info@alphaisolutions.com
                                        </a>
                                    </li>
                                    <li>
                                        <span className="businessForm-module--rightLabel--f1b4e">
                                            Whatsapp
                                        </span>
                                        <a
                                            className="businessForm-module--ptSans--61e94"
                                            href="tel:+968 991 60 109"
                                        >
                                            +968 991 60 109
                                        </a>
                                       
                                    </li>
                             </ul>
                            </div>
                        </div>
                    </form>
                </div>
            </section>
        </>
    );
};

export default WriteToUs;
